import axiosIns from '@/api/axios'

export const GET_PROJECT_TYPE = (args) => {
    return axiosIns.get('/master-data/project-type', args)
}

